import React from "react";
import { withRouter } from "react-router";

import Step from "./Step";
import { stepRoutesMapping } from "../../utils/stepperConfig";

const Stepper = ({ location: { pathname } }) => {
  const routeConfig = stepRoutesMapping[pathname];

  if (routeConfig) {
    return (
      <>
        <div>
          {routeConfig.map((config, index) => (
            <Step
              isLast={index === routeConfig.length - 1}
              config={config}
              key={index}
            />
          ))}
        </div>
      </>
    );
  }

  return null;
};

export default withRouter(Stepper);
